
export const AbilityActions = {
    READ: 'read',
    CREATE: 'create',
    UPDATE: 'update',
    DELETE: 'delete',
}

export const AbilitySubjects = {
    AUTH: 'Auth',
    DASHBOARD: 'dashboard',
    CALENDAR: 'calendar',
}

export const ReadOnlyAbility = [
    {
        action: AbilityActions.READ,
        subject: AbilitySubjects.CALENDAR,
    }
]

export const AdminAbility = [
    {
        action: AbilityActions.READ,
        subject: AbilitySubjects.AUTH,
    },
    {
        action: AbilityActions.READ,
        subject: AbilitySubjects.CALENDAR,
    },
    {
        action: AbilityActions.READ,
        subject: AbilitySubjects.DASHBOARD,
    },
    {
        action: AbilityActions.UPDATE,
        subject: AbilitySubjects.CALENDAR,
    },
]

